import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modalAberto: false,
  idSimulacao: null,
  lista: {
    loading: false,
    error: null,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10
  },
  filtros: {
    dataInicioFrom: null,
    dataInicioTo: null,
    flagSuccesso: null,
    codigoFluxo: [],
    tipoEvento: []
  },
  sort: { field: 'dataHoraInicio', direction: 'desc' },
  detalhe: {
    loading: false,
    error: null,
    data: null,
    idSelecionado: null
  }
};

const LogsIntegracaoSlice = createSlice({
  name: 'logsIntegracao',
  initialState,
  reducers: {
    abrirModal: (state, action) => {
      state.modalAberto = true;
      state.idSimulacao = action.payload?.idSimulacao ?? null;
      state.lista.page = 1;
      state.filtros = { ...initialState.filtros };
      state.sort = { ...initialState.sort };
      state.detalhe = { ...initialState.detalhe };
    },
    fecharModal: (state) => {
      state.modalAberto = false;
      state.idSimulacao = null;
      state.lista = { ...initialState.lista };
      state.detalhe = { ...initialState.detalhe };
    },
    alterarFiltros: (state, action) => {
      state.filtros = { ...state.filtros, ...action.payload };
      state.lista.page = 1;
    },
    alterarPaginacao: (state, action) => {
      const { page, pageSize } = action.payload || {};
      if (typeof page === 'number') state.lista.page = page;
      if (typeof pageSize === 'number') state.lista.pageSize = pageSize;
    },
    alterarSort: (state, action) => {
      state.sort = action.payload;
      state.lista.page = 1;
    },
    listarRequest: (state) => {
      state.lista.loading = true;
      state.lista.error = null;
    },
    listarSuccess: (state, action) => {
      const payload = action.payload?.response?.data ?? {};
      state.lista.loading = false;
      state.lista.error = null;
      state.lista.data = payload.data ?? [];
      state.lista.total = payload.total ?? 0;
    },
    listarFailure: (state, action) => {
      state.lista.loading = false;
      state.lista.error = action.payload;
      state.lista.data = [];
      state.lista.total = 0;
    },
    selecionarLog: (state, action) => {
      state.detalhe.idSelecionado = action.payload;
      state.detalhe.data = null;
      state.detalhe.error = null;
    },
    detalheRequest: (state) => {
      state.detalhe.loading = true;
      state.detalhe.error = null;
    },
    detalheSuccess: (state, action) => {
      state.detalhe.loading = false;
      state.detalhe.error = null;
      state.detalhe.data = action.payload?.response?.data ?? null;
    },
    detalheFailure: (state, action) => {
      state.detalhe.loading = false;
      state.detalhe.error = action.payload;
      state.detalhe.data = null;
    }
  }
});

export const {
  abrirModal,
  fecharModal,
  alterarFiltros,
  alterarPaginacao,
  alterarSort,
  listarRequest,
  listarSuccess,
  listarFailure,
  selecionarLog,
  detalheRequest,
  detalheSuccess,
  detalheFailure
} = LogsIntegracaoSlice.actions;

export default LogsIntegracaoSlice.reducer;
